import React from 'react';
import type {TableColumnsType} from 'antd';
import {Button, Table} from 'antd';
import {ZipcodeType} from "../graphql/queries/getZipcodeListing";
import { useTranslation } from 'react-i18next';

interface ZipcodeColumnsProps {
    zipcodeData: ZipcodeType[];
    loading: boolean;
    rowSelection?: {
        selectedRowKeys: React.Key[];
        onChange: (selectedKeys: React.Key[]) => void;
    };
    onGeofenceBlacklist?: (record: ZipcodeType) => void;
}

export const ZipcodeColumns: React.FC<ZipcodeColumnsProps> = ({
    zipcodeData,
    loading,
    rowSelection,
    onGeofenceBlacklist
}) => {
    const {t} = useTranslation();
    const zipcodeColumns: TableColumnsType<ZipcodeType> = [
        {
            title: t('central.zipcodes.columns.zipcode'),
            dataIndex: 'zipcode',
            key: 'zipcode',
            align: 'left' as const,
            width: 100,
            ellipsis: false,
            render: (text: string) => <span style={{ whiteSpace: 'nowrap' }}>{text || '-'}</span>
        },
        {
            title: t('central.zipcodes.columns.country'),
            dataIndex: 'country',
            key: 'country',
            align: 'left' as const,
            width: 80,
            ellipsis: false,
            render: () => <span style={{ whiteSpace: 'nowrap' }}>US</span>
        },
        {
            title: t('central.zipcodes.columns.state'),
            dataIndex: 'state',
            key: 'state',
            align: 'left' as const,
            width: 80,
            ellipsis: false,
            render: (text: string) => <span style={{ whiteSpace: 'nowrap' }}>{text || '-'}</span>
        },
        {
            title: t('central.zipcodes.columns.city'),
            dataIndex: 'city',
            key: 'city',
            align: 'left' as const,
            width: 150,
            ellipsis: false,
            render: (text: string) => <span style={{ whiteSpace: 'nowrap' }}>{text || '-'}</span>
        },
        {
            title: t('central.zipcodes.columns.timezone'),
            dataIndex: 'timezone',
            key: 'timezone',
            align: 'left' as const,
            width: 120,
            ellipsis: false,
            render: (text: string) => <span style={{ whiteSpace: 'nowrap' }}>{text || '-'}</span>
        },
        {
            title: t('central.zipcodes.columns.latitude'),
            dataIndex: 'latitude',
            key: 'latitude',
            align: 'left' as const,
            width: 120,
            ellipsis: false,
            render: (value: number) => <span style={{ whiteSpace: 'nowrap' }}>{value ? value.toFixed(3) : '-'}</span>
        },
        {
            title: t('central.zipcodes.columns.longitude'),
            dataIndex: 'longitude',
            key: 'longitude',
            align: 'left' as const,
            width: 120,
            ellipsis: false,
            render: (value: number) => <span style={{ whiteSpace: 'nowrap' }}>{value ? value.toFixed(3) : '-'}</span>
        },
        {
            title: t('wms.zipcodeMapGeofence.columns.actions'),
            key: 'operations',
            align: 'left' as const,
            width: 120,
            render: (_: unknown, record: ZipcodeType) => (
                <Button
                    type="link"
                    size="small"
                    className="p-0 font-semibold"
                    disabled={!record.isBoundary}
                    onClick={() => onGeofenceBlacklist?.(record)}
                >
                    {t('wms.zipcodeMapGeofence.title')}
                </Button>
            ),
        },
    ];

    return (
        <Table
            loading={loading}
            rowKey="zipcode"
            columns={zipcodeColumns}
            dataSource={zipcodeData}
            scroll={{x: 'max-content'}}
            size="middle"
            tableLayout="auto"
            pagination={false}
            className="mb-4"
            rowSelection={rowSelection}
        />
    );
}; 